export default "__VITE_ASSET__dfcc48e0__"